import { render, staticRenderFns } from "./PermissionsWrapper.vue?vue&type=template&id=1a2ff13c"
import script from "./PermissionsWrapper.vue?vue&type=script&lang=js"
export * from "./PermissionsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports